import React, { useContext } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import useApi from "../Api/Api";
import SalesLayout from "./SalesLayout";
import useEvents from "../hooks/useEvents";
import WebSalesLayout from "./WebSalesLayout";
import Button from "../Components/Button";
import { UserContext } from "../Auth/UserContextProvider";
import { Link } from "react-router-dom";

const WebSalesHistory = () => {
  const api = useApi();
  const { isAdmin } = useContext(UserContext);

  const {
    events,
    pagy,
    currentPage,
    setCurrentPage,
    getEvents,
  } = useEvents("web", "");

  const handlePageChange = (e) => {
    setCurrentPage(e.target.value);
  };

  const deleteEvent = (e, eventToDelete) => {
    e.preventDefault();
    const check = window.confirm(
      `Are you sure you want to delete ${eventToDelete.name}?`
    );
    if (check) {
      api.delete(`events/${eventToDelete.id}`).then(() => {
        getEvents(currentPage);
      });
    }
  };

  return (
    <SalesLayout>
      <WebSalesLayout>
        <div>
          {events.length > 0 ? (
            <div className="-mx-12">
              <form>
                <table>
                  <thead className="text-xs font-light">
                    <tr className="text-left border-b-2 h-11 w-full text-black">
                      <td className="pl-6 w-1/5">MONTH</td>
                      <td className="w-thin text-center">GROSS SALES</td>
                      {isAdmin && (
                        <td className="w-thin text-center">ACTION</td>
                      )}
                    </tr>
                  </thead>
                  <tbody>
                    {events.map((eventToRender, i) => {
                      const year = eventToRender.formattedDate.split("/")[2];
                      const month = eventToRender.formattedDate.split("/")[0];
                      return (
                        <tr
                          key={eventToRender.id}
                          className="border-b text-sm h-11"
                        >
                          <td id={`name_${i}`} className="pl-6 text-blue-500">
                            <Link to={`/sales/websales/view/${year}/${month}`}>
                              {eventToRender.name}
                            </Link>
                          </td>
                          {eventToRender?.gross_sales ? (
                            <td className="text-center" id={`gross_sales_${i}`}>
                              ${" "}
                              {eventToRender.gross_sales?.toLocaleString(
                                undefined,
                                {
                                  maximumFractionDigits: 2,
                                  minimumFractionDigits: 2,
                                }
                              )}
                            </td>
                          ) : (
                            <td></td>
                          )}
                          {isAdmin && (
                            <td className="text-center">
                              <button
                                onClick={(e) => deleteEvent(e, eventToRender)}
                              >
                                <FontAwesomeIcon
                                  icon={faTrash}
                                ></FontAwesomeIcon>
                              </button>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </form>
            </div>
          ) : (
            <div className="mx-12 py-16">
              No events have been added for this artist yet
            </div>
          )}
        </div>
      </WebSalesLayout>
      {events.length > 0 && (
        <footer className="text-sm -mt-8 mx-8 flex justify-between">
          <div className="ml-1 mr-8">
            Showing <span className="font-bold">{pagy.from} </span>to
            <span className="font-bold"> {pagy.to} </span>of
            <span className="font-bold"> {pagy.count} </span>results
          </div>
          <div className="mr-8">
            Page {pagy.page} of {pagy.last}
          </div>
          <div className="flex -mt-2">
            <span>
              <Button
                value={1}
                className={
                  pagy.page === 1
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="First"
                disabled={pagy.page === 1}
              ></Button>
            </span>
            <span className="mx-1">
              <Button
                value={pagy.prev}
                className={
                  !pagy.prev
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Prev"
                disabled={!pagy.prev}
              ></Button>
            </span>
            <span>
              <Button
                value={pagy.next}
                className={
                  !pagy.next
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Next"
                disabled={!pagy.next}
              ></Button>
            </span>
            <span className="ml-1">
              <Button
                value={pagy.last}
                className={
                  pagy.page === pagy.last
                    ? "button-white-disabled button-sm"
                    : "button button-white button-sm"
                }
                onClick={handlePageChange}
                text="Last"
                disabled={pagy.page === pagy.last}
              ></Button>
            </span>
          </div>
        </footer>
      )}
    </SalesLayout>
  );
};

export default WebSalesHistory;
